export enum SessionState {
  NONE,
  WAITING_FOR_PERMISSION,
  STARTED,
  CLOSING,
  ENDED
}
